export default __webpack_public_path__ + "media/SpotifyCompactDark.2f517c1e.png";